import React, { ReactNode } from 'react';
import classNames from 'classnames';
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
  Icons,
  Button,
} from '../';

import NavBar from '../NavBar';

// Todo: we should move this component to composition and remove props base

interface HeaderProps {
  children?: ReactNode;
  menuOptions: Array<{
    title: string;
    icon?: string;
    onClick: () => void;
  }>;
  isReturnEnabled?: boolean;
  onClickReturnButton?: () => void;
  isSticky?: boolean;
  WhiteLabeling?: {
    createLogoComponentFn?: (React: any, props: any) => ReactNode;
  };
  PatientInfo?: ReactNode;
  Secondary?: ReactNode;
  UndoRedo?: ReactNode;
}

function Header({
  children,
  menuOptions,
  isReturnEnabled = true,
  onClickReturnButton,
  isSticky = false,
  WhiteLabeling,
  PatientInfo,
  UndoRedo,
  Secondary,
  ...props
}: HeaderProps): ReactNode {
  // const onClickReturn = () => {
  //   if (isReturnEnabled && onClickReturnButton) {
  //     onClickReturnButton();
  //   }
  // };
  const logoResponsive = window.innerWidth > 640;
  const hostname = window.location.hostname;
  const url = 'radoviewerlite.medespacio.com';

  return (
    <NavBar
      isSticky={isSticky}
      {...props}
    >
      <div className="relative h-[48px] w-full items-center">
        <div className="absolute left-0 top-1/2 flex -translate-y-1/2 items-center justify-between">
          <div
            className={classNames('mr-3 inline-flex items-center', isReturnEnabled)}
            // onClick={onClickReturn}
            // data-cy="return-to-work-list"
          >
            {/* BOTON PARA RETROCEDER  AL WORKLIST*/}
            {/* {isReturnEnabled && <Icons.ArrowLeft className="text-primary ml-1 h-7 w-7" />} */}

            <div className="ml-1">
              {WhiteLabeling?.createLogoComponentFn?.(React, props) || logoResponsive ? (
                hostname === url ? (
                  <Icons.RadoViewerLogo />
                ) : (
                  <Icons.RadoViewerLogoM />
                )
              ) : hostname === url ? (
                <Icons.LogoCaduceo />
              ) : (
                <Icons.RadoViewerLogoSmall />
              )}
            </div>
          </div>
        </div>

        <div className="absolute top-1/2 left-[250px] h-8 -translate-y-1/2">{Secondary}</div>
        <div className="absolute top-1/2 left-1/2 -translate-y-1/2 transform max-sm:left-8 max-sm:w-[90%] sm:-translate-x-1/2">
          <div className="flex items-center justify-center max-sm:w-[90%]">{children}</div>
        </div>
        <div className="absolute right-0 top-1/2 flex -translate-y-1/2 select-none items-center">
          {UndoRedo}
          <div className="border-primary-dark mx-1.5 h-[25px] border-r max-sm:hidden"></div>
          {PatientInfo}
          <div className="border-primary-dark mx-1.5 h-[25px] border-r"></div>
          <div className="flex-shrink-0">
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button
                  variant="ghost"
                  size="icon"
                  className="text-primary hover:bg-primary-dark mt-2 h-full w-full"
                >
                  <Icons.GearSettings />
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end">
                {menuOptions.map((option, index) => {
                  const IconComponent = option.icon
                    ? Icons[option.icon as keyof typeof Icons]
                    : null;
                  return (
                    <DropdownMenuItem
                      key={index}
                      onSelect={option.onClick}
                      className="flex items-center gap-2 py-2"
                    >
                      {IconComponent && (
                        <span className="flex h-4 w-4 items-center justify-center">
                          <Icons.ByName name={IconComponent.name} />
                        </span>
                      )}
                      <span className="flex-1">{option.title}</span>
                    </DropdownMenuItem>
                  );
                })}
              </DropdownMenuContent>
            </DropdownMenu>
          </div>
        </div>
      </div>
    </NavBar>
  );
}

export default Header;
